document.addEventListener("DOMContentLoaded", () => {
    const inputSearchSelector = `.quick-search__input`;
    let debounceTimer;
    document.addEventListener("input", (e) => {
        if (e.target && e.target.matches(inputSearchSelector)) {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                window.dispatchEvent(new Event('scroll'));
            }, 300);
        }
    });
});

document.addEventListener("bss_b2b:CustomCartUpdate", () => {
    window.dispatchEvent(new Event('scroll'));
});
